import { Button, Modal } from '@mantine/core'
import React from 'react'
import { Link } from 'react-router-dom'

export default function LibraryResultModal({ opened, onClose, state, setState }) {
   return (
      <Modal
         size='auto'
         opened={opened}
         onClose={onClose}
      >
         <div className='Library-content-modal-wrapper'>

            {state.status === 'error'
               ? <>
                  <h3 className='Library-content--title'>Acceso denegada</h3>
                  <p className='Library-content--description'>{state.message}</p>

                  <p className='Library-content--description'>¿Querés acceder a todo el material exclusivo sin límites?</p>

                  <Button
                     color='#e1568b'
                     variant='light'
                     component={Link}
                     target='_blank'
                     to='https://forvet.org/suscripciones'
                     // to={`${process.env.REACT_APP_FRONTEND_SERVER}/suscripciones`}
                  >
                     Accedé al plan sin límites
                  </Button>
               </>
               : <>
                  <h3 className='Library-content--title'>Accede a tu contenido</h3>
                  <p className='Library-content--description'>Hace click en el siguiente enlace para verlo</p>
                  <Link target='_blank' style={{ color: 'inherit', textDecoration: "underline", fontSize: "var(--fs-body)" }} to={state.message}>Ir al contenido</Link>
               </>
            }
            <Button onClick={() => setState({
               status: null,
               message: ""
            })}
            >
               Cerrar
            </Button>
         </div>
      </Modal>
   )
}
